import { render, staticRenderFns } from "./DataInfo.vue?vue&type=template&id=b81e206c"
import script from "./DataInfo.vue?vue&type=script&lang=ts"
export * from "./DataInfo.vue?vue&type=script&lang=ts"
import style0 from "./DataInfo.vue?vue&type=style&index=0&id=b81e206c&prod&lang=scss"
import style1 from "./DataInfo.vue?vue&type=style&index=1&id=b81e206c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports